import { CONTACTS as ALL_CONTACTS } from '../data/resume';

// Контакты для сайта: шапка резюме, блок внизу страницы и общий футер.
// Записи с pdfOnly (например, ссылка на сам сайт) нужны только в PDF-версии CV.
export const CONTACTS = ALL_CONTACTS.filter((contact) => !contact.pdfOnly);
